<template>
    <div>
        <div class="div" v-for="item in menuList" :key="item.id">
            <el-submenu 
                v-if="item.children && item.children.length > 0" 
                :index="item.value"
                :popper-class="'edge-aware-popper submenu-' + item.value">
                <template slot="title">{{ item.className }}</template>
                <recursive-menu :menu-list="item.children" />
            </el-submenu>
            <el-menu-item v-else :index="item.value">
                {{ item.className }}
            </el-menu-item>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RecursiveMenu',
    props: {
        menuList: {
            type: Array,
            default: () => []
        }
    },
    mounted() {
        this.initMenuListener();
    },
    beforeDestroy() {
        // 清理监听器
        if (this.globalObserver) {
            this.globalObserver.disconnect();
        }
    },
    methods: {
        initMenuListener() {
            this.$nextTick(() => {
                // 使用全局 MutationObserver 监听 DOM 变化
                this.globalObserver = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.type === 'childList') {
                            // 检查是否有新的弹出菜单添加到 body
                            mutation.addedNodes.forEach((node) => {
                                if (node.nodeType === 1 && 
                                    node.classList && 
                                    node.classList.contains('edge-aware-popper')) {
                                    this.handlePopupMenu(node);
                                }
                            });
                        }
                    });
                });

                // 开始观察整个文档 body 的变化
                this.globalObserver.observe(document.body, {
                    childList: true,
                    subtree: true
                });

                // 同时监听已存在的弹出菜单
                const existingPopups = document.querySelectorAll('.edge-aware-popper');
                existingPopups.forEach(popup => {
                    this.handlePopupMenu(popup);
                });
            });
        },
        
        handlePopupMenu(popup) {
            if (!popup) return;
            
            // 创建针对该弹出菜单的观察器
            const popupObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                        this.adjustPopupPosition(popup);
                    }
                });
            });
            
            // 观察该弹出菜单的样式变化
            popupObserver.observe(popup, {
                attributes: true,
                attributeFilter: ['style']
            });
            
            // 初始调整一次位置
            this.adjustPopupPosition(popup);
        },

        adjustPopupPosition(popup) {
            if (!popup) return;
            
            this.$nextTick(() => {
                // 使用防抖避免频繁计算
                if (this.adjustTimer) {
                    clearTimeout(this.adjustTimer);
                }
                
                this.adjustTimer = setTimeout(() => {
                    const rect = popup.getBoundingClientRect();
                    const windowWidth = window.innerWidth;
                    const windowHeight = window.innerHeight;
                    
                    // 检查右侧是否超出屏幕
                    if (rect.right > windowWidth) {
                        const overflow = rect.right - windowWidth;
                        const currentTransform = popup.style.transform || '';
                        
                        // 解析当前transform值
                        let translateX = 0;
                        if (currentTransform.includes('translateX')) {
                            const match = currentTransform.match(/translateX$$([^$$]+)$$/);
                            if (match) {
                                translateX = parseFloat(match[1]) || 0;
                            }
                        }
                        
                        // 计算新的X轴偏移量
                        const newTranslateX = translateX - overflow - 10;
                        const translateYMatch = currentTransform.match(/translateY$$([^$$]+)$$/);
                        const translateY = translateYMatch ? translateYMatch[1] : '0px';
                        
                        // 应用新的变换
                        popup.style.transform = `translateX(${newTranslateX}px) translateY(${translateY})`;
                    }
                    
                    // 检查左侧是否超出屏幕
                    if (rect.left < 0) {
                        const currentTransform = popup.style.transform || '';
                        const translateYMatch = currentTransform.match(/translateY$$([^$$]+)$$/);
                        const translateY = translateYMatch ? translateYMatch[1] : '0px';
                        popup.style.transform = `translateX(0px) translateY(${translateY})`;
                    }
                    
                    // 检查底部是否超出屏幕
                    if (rect.bottom > windowHeight) {
                        const overflow = rect.bottom - windowHeight;
                        popup.style.maxHeight = `${windowHeight - rect.top - 10}px`;
                        popup.style.overflowY = 'auto';
                    }
                }, 50); // 50ms 防抖延迟
            });
        }
    }
}
</script>

<style scoped>
.edge-aware-popper {
    max-width: none !important;
}

/* 确保弹出菜单不会被截断 */
.edge-aware-popper.el-menu--popup {
    z-index: 3000 !important;
}
::v-deep .el-submenu__title,::v-deep .el-menu-item{
    height: 6.5vh;
}
::v-deep .el-menu-item, ::v-deep .el-submenu__title{
    line-height: 6.5vh;
}
::v-deep .el-submenu__title,::v-deep .el-menu-item{
    font-size: 0.9vw !important;
}
</style>